import type { CreateAssignmentPayload } from "@/api/form-builder-assignments/formBuilderAssignments.types";
import type { ProposedAssignmentChange } from "@/api/form-builder/formAssistant.types";

export function toCreatePayload(
  change: ProposedAssignmentChange,
  tenantId: string,
): CreateAssignmentPayload | null {
  const { assignment } = change;
  if (!assignment.templateId) return null;
  return {
    tenantId,
    workOrderType: assignment.workOrderType,
    formType: assignment.formType,
    templateId: assignment.templateId,
    ...(assignment.clientId ? { clientId: assignment.clientId } : {}),
    ...(assignment.brandId ? { brandId: assignment.brandId } : {}),
    ...(assignment.tradeId !== null ? { tradeId: assignment.tradeId } : {}),
    ...(assignment.subtradeId !== null ? { subtradeId: assignment.subtradeId } : {}),
  };
}
